<template>
  <v-card class="my-3" v-if="data">
    <v-card-title class="subtitle-1 card-title-head">
      {{ data.corporate.name }}

      <!-- <span v-if="!expand.vd" style="margin-left: 30px"
        ><v-icon>mdi-car</v-icon>
        {{ trip.vehicle ? trip.vehicle.regNo : "" }}
        {{
          trip.vehicle ? "( " + trip.vehicle.vehicleTypeStr + " )" : ""
        }}</span
      >
      <span v-if="!expand.vd" style="margin-left: 30px"
        ><v-icon>mdi-steering</v-icon>
        {{ trip.driver ? trip.driver.name : "" }}
        {{
          trip.driver
            ? "( " + trip.driver.countryCode + " " + trip.driver.phone + " )"
            : ""
        }}</span
      > -->
    </v-card-title>
    <v-expand-transition>
      <v-card-text class="py-0 text-body-1">
        <v-simple-table dense>
          <template v-slot:default>
            <thead class="thead">
              <tr>
                <th class="text-left" style="width: 40px">
                  <v-checkbox
                    v-model="selectAll"
                    style="padding: 0; float: left; width: 30px"
                  />
                </th>
                <th class="text-left">
                  {{ $i18n.t("Seq No.") }}
                </th>
                <th class="text-left">
                  {{ $i18n.t("Ref No.") }}
                </th>
                <th class="text-left">
                  {{ $i18n.t("Entity") }}
                </th>
                <th class="text-left">
                  {{ $i18n.t("GRN/LR No.") }}
                </th>
                <th class="text-left">
                  {{ $i18n.t("GRN/LR Date") }}
                </th>
                <th class="text-left">
                  {{ $i18n.t("Client Entity") }}
                </th>
                
                <th class="text-left">
                  {{ $i18n.t("Date") }}
                </th>
                <th class="text-left">
                  {{ $i18n.t("Created At") }}
                </th>
                <th class="text-left">
                  {{ $i18n.t("Payment #") }}
                </th>
                <th class="text-left">
                  {{ $i18n.t("Vendor Name") }}
                </th>
                <th class="text-left">
                  {{ $i18n.t("Mode") }}
                </th>
                <th class="text-right">
                  {{ $i18n.t("Amount") }}
                </th>
                <th class="text-right">
                  <v-btn
                    class="float-right"
                    text
                    fab
                    x-small
                    color="blue"
                    @click="markPayment()"
                  >
                    <v-icon>mdi-credit-card-outline</v-icon>
                  </v-btn>
                </th>
              </tr>
            </thead>
            <tbody
              class="tbody"
              v-for="payment in data.paymentMades"
              :key="payment._id"
            >
              <tr style="height: 50px">
                <td>
                  <v-checkbox
                    class="my-0"
                    v-model="payment.selected"
                    style="float: left"
                  />
                </td>
                <td>{{ payment.seqNo }}</td>
                <td>{{ payment.refNo }}</td>
                <td>{{ payment.entity ? payment.entity.name : "" }}</td>
                <td>{{ payment.billPayments && payment.billPayments[0] && payment.billPayments[0]['number']  ? payment.billPayments[0]['number'] : "" }}</td>
                <td>{{ payment.billPayments && payment.billPayments[0] && payment.billPayments[0]['lrDate']  ? payment.billPayments[0]['lrDate'] : "" }}</td>
                <td>{{ payment.billPayments && payment.billPayments[0] && payment.billPayments[0]['clientEntityName']  ? payment.billPayments[0]['clientEntityName'] : "" }}</td>
                <td>{{ formatDate(payment.date) }}</td>
                <td>{{ payment.createdAt | moment("HH:mm DD MMM YYYY") }}</td>
                <td>{{ payment.no }}</td>
                <td>{{ payment.vendorName ? payment.vendorName : "Other" }}</td>
                <td>{{ payment.paymentMode }}</td>
                <td class="text-right">
                  {{ payment.currency }} {{ payment.totalAmount }}
                </td>
                <td>
                  <v-btn
                    class="float-right"
                    text
                    fab
                    x-small
                    color="blue"
                    @click="markPayment(payment)"
                  >
                    <v-icon>mdi-credit-card-outline</v-icon>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-expand-transition>

    <payment-pending-entry
      @select="selectPayment"
      :showDialog="entryCreateDialog"
      :value="payments"
    ></payment-pending-entry>
  </v-card>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import { doGet } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import PaymentPendingEntry from "@/views/paymentpending/PaymentPendingEntry.vue";

@Component({
  name: "PaymentPendingRow",
  components: { PaymentPendingEntry },
  props: {
    value: {
      default: null,
    },
    refresh: {
      default: null,
    },
  },
})
export default class PaymentPendingRow extends Vue {
  data = null;
  selectAll = false;
  entryCreateDialog = false;
  payments = [];

  get loading() {
    return common.loading;
  }

  selectPayment() {
    this.entryCreateDialog = false;
    this.$emit("reload", null);
  }

  markPayment(payment) {
    this.payments = [];
    if (payment) {
      this.payments.push(payment);
    } else {
      for (let i = 0; i < this.data.paymentMades.length; i++) {
        if (this.data.paymentMades[i].selected) {
          this.payments.push(this.data.paymentMades[i]);
        }
      }
    }
    if (this.payments.length == 0) {
      common.setError("Please select at least one entry.");
      return;
    }
    this.entryCreateDialog = true;
  }

  async mounted() {
    if (this.value) {
      this.data = this.value;
    }
  }

  @Watch("value")
  onValueChange(val) {
    this.selectAll = false;
    if (val) {
      for (let i = 0; i < val.paymentMades.length; i++) {
        val.paymentMades[i].selected = false;
      }
    }
    this.data = val;
  }

  @Watch("selectAll")
  onSelectedChange(val) {
    for (let i = 0; i < this.data.paymentMades.length; i++) {
      this.data.paymentMades[i].selected = val;
    }
  }

  formatDate(date) {
    if (date) {
      const dateStr = date.toString();
      return (
        dateStr.substring(6, 8) +
        "-" +
        dateStr.substring(4, 6) +
        "-" +
        dateStr.substring(0, 4)
      );
    } else {
      return "";
    }
  }

  isSet(_key) {
    if (
      _key != null &&
      _key != undefined &&
      _key != "null" &&
      _key != "undefined" &&
      _key != ""
    ) {
      return true;
    }
    return false;
  }

  subtract(from, value) {
    if (!this.isSet(from)) from = 0;
    if (!this.isSet(value)) value = 0;
    return this.round(from) - this.round(value);
  }

  round(value) {
    return Number(Math.round(value + "e" + 2) + "e-" + 2);
  }
}
</script>
